import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="validation-matricula"
export default class extends Controller {
  static targets = [ "form", "matriculaInput", "nombreInput", "tabs" ]
  static values = {
    id: String
  }

  connect() {
    this.element.addEventListener('keydown', this.preventFormSubmitOnEnter.bind(this));
    this.element.addEventListener('keydown', this.handleModalKeydown.bind(this));

    document.addEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this));

    try {
      if (this.hasMatriculaInputTarget && this.matriculaInputTarget) {
        this.matriculaInputTarget.addEventListener('input', () => {
          const hidden = document.querySelector('#matriculaValidacionModal [data-autocomplete-target="hidden"]');
          if (hidden) hidden.value = '';
        });
      }
    } catch (e) {}
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.preventFormSubmitOnEnter.bind(this));
    this.element.removeEventListener('keydown', this.handleModalKeydown.bind(this));
    document.removeEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this));
  }

  handleSubmitEnd(event) {
    if (event.target.id === this.idValue && this.originalSubmitButton) {
      setTimeout(() => {
        this.originalSubmitButton.disabled = false;
        this.originalSubmitButton.classList.remove('disabled');
      }, 100);
    }
  }

  preventFormSubmitOnEnter(event) {
    if (event.key === 'Enter') {
      const target = event.target;
      const form = document.getElementById(this.idValue);

      const isInModal = target.closest('#matriculaValidacionModal');

      if (!isInModal && form.contains(target)) {
        const isTrixEditor = target.tagName === 'TRIX-EDITOR' || target.closest('trix-editor');
        if (isTrixEditor) {
          return;
        }

        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          event.preventDefault();
          return false;
        }
      }
    }
  }

  handleModalKeydown(event) {
    if (event.key === 'Enter') {
      const target = event.target;
      const isInModal = target.closest('#matriculaValidacionModal');

      if (isInModal && this.hasMatriculaInputTarget) {
        event.preventDefault();

        const matriculaValue = this.matriculaInputTarget.value;

        if (matriculaValue) {
          this.submitForm();
        } else {
          this.matriculaInputTarget.focus();
        }
      }
    }
  }

  openModal(e) {
    e.preventDefault();
    this.originalSubmitButton = e.target;
    if (this.originalSubmitButton.classList.contains("disabled")) {
      return;
    }

    $('#matriculaValidacionModal').modal('show');
  }

  submitForm() {
    const matriculaTexto = this.hasMatriculaInputTarget ? this.matriculaInputTarget.value.trim() : ''
    const hiddenField = document.querySelector('#matriculaValidacionModal [data-autocomplete-target="hidden"]')
    const matriculaSeleccionada = hiddenField ? (hiddenField.value || '').toString().trim() : ''

    if (matriculaTexto === '' || matriculaSeleccionada === '') {
      alert('Debes seleccionar un profesional del buscador. Escribe y elige una opción de la lista desplegable.');
      return
    }

    const form = document.getElementById(this.idValue)
    form.requestSubmit();
    $('#matriculaValidacionModal').modal('hide');
  }

  getActiveTabName() {
    if (!this.hasTabsTarget) return null

    const activeTab = this.tabsTarget.querySelector(".nav-link.active")
    if (activeTab) {
      return activeTab.textContent.trim()
    }
    return null
  }

  closeModal() {
    $('#matriculaValidacionModal').modal('hide');
  }
}
